import React from "react";
import { Button } from "react-bootstrap";
import "../warranty.css";

// Fixed minimum heights so a screen does not jump when its data arrives.
export const Loading = ({ label = "Loading" }) => (
  <div className="warranty-state" role="status" aria-live="polite">
    <div className="warranty-spinner" aria-hidden="true"></div>
    <div>{label}</div>
  </div>
);

export const EmptyState = ({ title, children }) => (
  <div className="warranty-state">
    <i className="bi bi-inbox warranty-state-icon" aria-hidden="true"></i>
    <div>
      <strong>{title}</strong>
    </div>
    {children}
  </div>
);

export const ErrorState = ({ message, onRetry, retrying = false }) => (
  <div className="warranty-state is-error" role="alert">
    <i className="bi bi-exclamation-triangle warranty-state-icon" aria-hidden="true"></i>
    <div>{message}</div>
    {onRetry && (
      <Button className="Addbtn" onClick={onRetry} disabled={retrying}>
        {retrying ? "Retrying" : "Retry"}
      </Button>
    )}
  </div>
);
